import React, { useState, useCallback } from "react"
import "./ShipmentManagement.scss"
import { Tab } from 'react-bootstrap';
import { Spin, Form } from 'antd';
import { useLocation } from 'react-router-dom';
import ShipmentManagementHeader from "./ShipmentManagementHeader/ShipmentManagementHeader";
import ShipmentManagementContent from "./ShipmentManagementContent/ShipmentManagementContent";
import { useFetch } from "../../utils/hooks";
import { getShipmentsListTotals } from "../../services/shipments";
import ShipmentManagementSubHeader from "./ShipmentManagementSubHeader/ShipmentManagementSubHeader";
import ShipmentManagementSearchBar from "./ShipmentManagementSearchBar/ShipmentManagementSearchBar";
import { FilterCounterProvider } from "../Filters/FilterCounterContext";
import CompanyMetrics from "../CompanyMetrics/CompanyMetrics";

const ShipmentManagement = (props) => {
  const [bookingList, setBookingList] = useState([])
  const [filterList, setFilterList] = useState({})
  const [archiveTotal, setArchiveTotal] = useState(0)
  const location = useLocation();
  // Extract "as" parameter from URL
  const searchParams = new URLSearchParams(location.search);
  const asParam = searchParams.get('as'); // This will extract the "as" parameter
  const { data, loading, refetch } = useFetch(useCallback(() => getShipmentsListTotals({ bookingList, filterList, as: asParam }), [bookingList, filterList]))
  const [form] = Form.useForm();

  const totals = {
    total: data?.total,
    totalStarred: data?.total_starred,
    totalAttention: data?.total_attention
  }

  function addToBookingList(booking) {
    setBookingList([...bookingList, booking])
  }

  function removeFromBookingList(booking) {
    setBookingList(bookingList.filter(bookingEntry => bookingEntry !== booking))
  }

  function clearBookingList() {
    setBookingList([])
  }

  function filterBookingNumber(e) {
    addToBookingList(e.target.value);
    window.dispatchEvent(new Event('filter'));
    form.resetFields();
  }

  if (loading) {
    return <Spin className="spinner" size="large" />
  }

  return (
    <div className="ShipmentManagement">
      <ShipmentManagementHeader 
        addToBookingList={addToBookingList} 
        refetch={refetch} 
        archiveTotal={archiveTotal}
      />

      <CompanyMetrics />

      <Tab.Container defaultActiveKey="in_progress" unmountOnExit={true}>
        <FilterCounterProvider>
          <ShipmentManagementSearchBar form={form} totals={totals} filterBookingNumber={filterBookingNumber} filterList={filterList} setFilterList={setFilterList}/>
        </FilterCounterProvider>
        <ShipmentManagementSubHeader bookingList={bookingList} removeFromBookingList={removeFromBookingList} clearBookingList={clearBookingList} />

        <Tab.Content>
          {["in_progress", "starred", "attention"].map(eventKey => {
            return (
              <Tab.Pane key={eventKey} eventKey={eventKey}>
                <ShipmentManagementContent 
                  totals={totals} 
                  tab={eventKey} 
                  refetch={refetch} 
                  bookingList={bookingList} 
                  filterList={filterList} 
                  setArchiveTotal={setArchiveTotal}
                />
              </Tab.Pane>
            )
          })}
        </Tab.Content>
      </Tab.Container>
    </div>
  )
};

export default ShipmentManagement;
